import { dispatch, useReframe } from 'nike-re-framejs';
import React, { useContext, useEffect, useState } from 'react';

import i18n from '@i18n';
import { Tournament } from './TournamentList';
import InfiniteScroll from '@/responsive/components/InfiniteScroll/InfiniteScroll';
import DelayedAppear from '@/common/components/DelayedAppear';
import OverviewLoader from '../views/OverviewLoader';
import withSportHeader from '@/common/components/sportWrapper';
import NikeOneContext from '../context/NikeOneContext';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import { FavoritesInfo } from '@/favorites/components/FavoritesInfo';
import BackToTop from '@/common/components/BackToTop';
import { loadTodayMenu, refreshBoxes } from '@/nikeone/handlers';
import { liveTournamentIds$$ } from '@/nikeone/subs-detail';
import { useTurboLivePush } from 'nike-ui/src/components/turboLive/push/overview/useTurboLivePush';

export const TodayVisibleDates = ['ALL', 'TODAY', 'HOUR', 'HOURS3'];

export function isTodaySlugVisible(byDate) {
    return TodayVisibleDates.indexOf(byDate) > -1;
}

function TodayOfferLoader() {
    const derefSub = useReframe();
    const prematchOnly = derefSub(['nikeone/filter/isPrematchOnly']);
    useEffect(() => {
        dispatch(loadTodayMenu);
    }, [prematchOnly]);
    useEffect(() => {
        dispatch(refreshBoxes());
        return () => dispatch(refreshBoxes());
    }, []);
    return null;
}

const TodayOfferContent = React.memo(function TodayOfferContent() {
    const derefSub = useReframe();
    const liveTournamentIds = derefSub(liveTournamentIds$$('filteredBoxStore'));
    useTurboLivePush(liveTournamentIds);
    const [displayed, setDisplayed] = useState(15);
    const { favoritesOnly } = useContext(NikeOneContext);

    const todayMenu = derefSub(['nikeone.todayMenu']);
    if (!todayMenu) {
        return (
            <DelayedAppear delay={2200} loader={OverviewLoader} loaderDelay={200}>
                <noscript />
            </DelayedAppear>
        );
    }
    const favoriteBoxIds = derefSub(['favourite.ids.menuItems']);
    const [content, count, allCount] = renderLimitedTournaments(
        todayMenu,
        displayed,
        favoriteBoxIds,
        favoritesOnly
        //  activeTicketsBoxIds
    );
    if (!count) {
        return <EmptyState text={i18n('content.empty')} />;
    }

    return (
        <InfiniteScroll
            pageStart={0}
            loadMore={() => setDisplayed(displayed + 10)}
            hasMore={displayed < allCount}
            loader={
                <div key="super-loader" className="loading-text">
                    {i18n('commons.term.loading')}
                </div>
            }
            useWindow
            threshold={0}
        >
            {favoritesOnly ? <FavoritesInfo /> : null}
            {content}
            {allCount > 10 ? <BackToTop /> : null}
        </InfiniteScroll>
    );
});

export function TodayOffer() {
    return (
        <div className="layout-offer-rw">
            <TodayOfferLoader />
            <TodayOfferContent />
        </div>
    );
}

function renderLimitedTournaments(todayMenu, limit, favoriteBoxIds, favoritesOnly, activeTicketsBoxIds) {
    const sports = [];
    let allCount = 0;
    let count = 0;
    todayMenu.get('sportList').forEach(sport => {
        const sportTournaments = [];
        const favTournaments = [];
        const otherTournaments = [];
        todayMenu.getIn(['tournamentsBySlug', sport.get('slug')]).forEach(t => {
            if (!activeTicketsBoxIds || activeTicketsBoxIds.has(t.boxId)) {
                allCount++;
                const toPush = favoriteBoxIds.has(t.boxId) ? favTournaments : otherTournaments;
                toPush.push(t);
            }
        });

        function tryAdd(tour) {
            if (count < limit) {
                sportTournaments.push(
                    <Tournament
                        key={tour.boxId}
                        tour={tour}
                        sportId={sport.get('sportId')}
                        statisticsId={tour.statisticsId}
                    />
                );
                count++;
            }
        }

        favTournaments.forEach(tryAdd);
        if (!favoritesOnly) {
            otherTournaments.forEach(tryAdd);
        }
        if (sportTournaments.length) {
            sports.push(withSportHeader(sport.get('sportId'), sport.get('label'), sportTournaments));
        }
    });
    return [sports, count, allCount];
}
